import type React from 'react'
import type { JSX } from 'react'
import type { DESCRIPTION_PADDINGS } from 'vars/index'

import { Fonts } from 'atoms/Label/Label.h'
import { LabelVerticalVideo, LabelWithBorderLeft } from 'atoms/Label/Templates'
import {
  DescriptionAlignItems,
  DescriptionColumnGap,
  DescriptionDirection,
  DescriptionJustifyContent,
  DescriptionRowGap,
} from './Description.h'
import {
  DescriptionLabelGroupSC,
  DescriptionStyled,
} from './Description.styled'

export interface IDescriptionProps {
  children?: React.ReactNode
  width?: number
  direction?: DescriptionDirection
  alignItems?: DescriptionAlignItems
  justifyContent?: DescriptionJustifyContent
  columnGap?: DescriptionColumnGap
  rowGap?: DescriptionRowGap
  paid?: boolean
  purchaseTitle?: string
  paddings?: DESCRIPTION_PADDINGS
  className?: string // https://github.com/callstack/linaria/blob/master/docs/BASICS.md#overriding-styles
  style?: React.CSSProperties
  rented?: boolean
  verticalVideo?: boolean
}

export const Description = ({
  children,
  width = 0,
  direction = DescriptionDirection.Column,
  alignItems = DescriptionAlignItems.FlexStart,
  justifyContent = DescriptionJustifyContent.FlexStart,
  columnGap = DescriptionColumnGap.INDENT_0,
  rowGap = DescriptionRowGap.INDENT_0,
  rented,
  paid,
  purchaseTitle,
  paddings,
  className = '',
  style,
  verticalVideo,
}: IDescriptionProps): JSX.Element => {
  const showLabelBorderLeft = paid || (rented && purchaseTitle)
  const showLabelVerticalVideo = verticalVideo

  return (
    <DescriptionStyled
      width={width}
      direction={direction}
      alignItems={alignItems}
      justifyContent={justifyContent}
      columnGap={columnGap}
      rowGap={rowGap}
      paddings={paddings}
      className={className}
      style={style}
    >
      {(showLabelBorderLeft || showLabelVerticalVideo) && (
        <DescriptionLabelGroupSC rented={rented}>
          {showLabelBorderLeft && (
            <LabelWithBorderLeft
              title={rented ? purchaseTitle : ''}
              withIcon={!rented}
              font={Fonts.Caption4}
            />
          )}
          {verticalVideo && (
            <LabelVerticalVideo data-testid='test-vertical-video-label' />
          )}
        </DescriptionLabelGroupSC>
      )}

      {children}
    </DescriptionStyled>
  )
}
